import type { FieldGroup } from './types.js';

export const lgbtqStatementOptions = [
  { value: 'LGBTQ_EQUAL_RIGHTS', label: 'LGBTQ+ people deserve equal rights' },
  { value: 'LGBTQ_SOCIAL_ACCEPTANCE', label: 'Society should accept LGBTQ+ people' },
  { value: 'LGBTQ_PRIVATE_MATTER', label: "It's a private matter" },
  { value: 'LGBTQ_SHOULD_NOT_BE_DISCRIMINATED', label: 'They should not face discrimination' },
  { value: 'LGBTQ_TRADITION_CONFLICT', label: 'It conflicts with our traditions' },
  { value: 'LGBTQ_NOT_COMFORTABLE', label: "I'm not comfortable with it" },
  { value: 'LGBTQ_DONT_KNOW', label: "I don't know enough about it" },
  { value: 'LGBTQ_PREFER_NOT_SAY', label: 'Prefer not to say' },
] as const;

export const transgenderStatementOptions = [
  {
    value: 'TRANS_CHILD_KEEP_IN_FAMILY',
    label: 'A transgender child should be kept in the family',
  },
  { value: 'TRANS_EQUAL_RIGHTS', label: 'Transgender people deserve equal rights' },
  { value: 'TRANS_PART_OF_NORMAL_SOCIETY', label: 'They are part of normal society' },
  { value: 'TRANS_NO_ABANDONMENT', label: 'No one should abandon a transgender family member' },
  { value: 'TRANS_ONLY_SPECIAL_COMMUNITY', label: 'They belong to their own special community' },
  { value: 'TRANS_UNCOMFORTABLE', label: "I'm uncomfortable around transgender people" },
  { value: 'TRANS_DONT_KNOW', label: "I don't know enough" },
  { value: 'TRANS_PREFER_NOT_SAY', label: 'Prefer not to say' },
] as const;

export const casteDiscriminationPlaceOptions = [
  { value: 'SCHOOL_EDUCATION', label: 'School / Education' },
  { value: 'WORKPLACE', label: 'Workplace' },
  { value: 'LOCALITY', label: 'Locality / Neighborhood' },
  { value: 'GOVT_OFFICES', label: 'Government offices' },
  { value: 'MARKET', label: 'Market / Shops' },
  { value: 'RELIGIOUS_SPACE', label: 'Religious spaces' },
  { value: 'OTHER', label: 'Other' },
] as const;

export const animalCrueltyOptions = [
  { value: 'strongly_against', label: 'Strongly against all forms' },
  { value: 'against_but_food', label: 'Against, but accept for food' },
  { value: 'neutral', label: 'Neutral' },
  { value: 'acceptable_in_tradition', label: 'Acceptable in tradition/culture' },
  { value: 'prefer_not_to_say', label: 'Prefer not to say' },
] as const;

export const casteDiscriminationOptions = [
  { value: 'YES_OFTEN', label: 'Yes, often' },
  { value: 'YES_SOMETIMES', label: 'Yes, sometimes' },
  { value: 'NO', label: 'No' },
  { value: 'PREFER_NOT_SAY', label: 'Prefer not to say' },
] as const;

export const genderEqualityOptions = [
  { value: 'strong_advocate', label: 'Strong advocate for equality' },
  { value: 'supportive', label: 'Supportive' },
  { value: 'traditional_values', label: 'I prefer traditional values' },
  { value: 'no_opinion', label: 'No opinion' },
  { value: 'prefer_not_to_say', label: 'Prefer not to say' },
] as const;

export const worldView: FieldGroup = {
  key: 'world_view',
  label: 'World View & Experience',
  step: 10,
  description: 'Views on social issues, equality, and discrimination.',
  fields: [
    {
      order: 1,
      key: 'viewOnAnimalCruelty',
      label: 'View on Animal Cruelty',
      type: 'single_select',
      step: 10,
      isOnboarding: true,
      optional: true,
      options: [...animalCrueltyOptions],
    },
    {
      order: 2,
      key: 'viewOnLgbtqStatements',
      label: 'Views on LGBTQ+ Rights',
      type: 'multi_select',
      step: 10,
      isOnboarding: true,
      optional: true,
      options: [...lgbtqStatementOptions],
    },
    {
      order: 3,
      key: 'viewOnTransgenderInclusion',
      label: 'Views on Transgender Inclusion',
      type: 'multi_select',
      step: 10,
      isOnboarding: true,
      optional: true,
      options: [...transgenderStatementOptions],
    },
    {
      order: 4,
      key: 'facingCasteDiscrimination',
      label: 'Caste Discrimination Experience',
      type: 'single_select',
      step: 10,
      isOnboarding: true,
      optional: true,
      sensitive: true,
      options: [...casteDiscriminationOptions],
    },
    {
      order: 5,
      key: 'casteDiscriminationPlaces',
      label: 'Where Discrimination Faced',
      type: 'multi_select',
      step: 10,
      isOnboarding: true,
      optional: true,
      options: [...casteDiscriminationPlaceOptions],
      conditionalOn: { field: 'facingCasteDiscrimination', values: ['YES_OFTEN', 'YES_SOMETIMES'] },
    },
    {
      order: 6,
      key: 'viewOnGenderEquality',
      label: 'View on Gender Equality',
      type: 'single_select',
      step: 10,
      isOnboarding: true,
      optional: true,
      options: [...genderEqualityOptions],
    },
  ],
};
